import { FC } from "react";
import cancel from "../../../assets/images/reject.svg";
import { Input } from "../../../components/ui";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../store";
import { setApprRejectFields } from "../../../reducers/marketSlice";

const RejectMarket = () => {

  const dispatch = useDispatch();

  const { apprRejectFields } = useSelector((state: TRootState) => ({
    apprRejectFields: state.marketDetails.apprRejectFields,
  }));

  return (
    <div>
      <div className=" flex flex-col gap-4 text-sm ">
        <div className="flex justify-center">
          <img src={cancel} className="w-10 " />
        </div>
        <p className="text-center">
          Are you sure you want to reject this request?
        </p>
        <div className="space_18">
          <Input
            label="Remarks (if any)"
            type="text"
            required={false}
            value={apprRejectFields?.rejectRemarks}
            className="flex-1"
            onChange={(e) => {
              dispatch(setApprRejectFields({
                ...apprRejectFields!,
                rejectRemarks: e.target.value
              }))
            }}
            palceholder="Tell why you are rejecting this request"
          />
        </div>
      </div>
    </div>
  );
};
export default RejectMarket;
